//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
let d=[[[1,"EndDistance",0,"Expression",0],[0,"ExtensionDirection",1,0],[0,"ExtensionMethod",1,0],[0,"ExtensionSide",1,0],[1,"StartDistance",0,"Expression",0],[1,"TotalLength",0,"Expression",0]],[[["start_distance"],"SetStartDistance",{},1,0],[["end_distance"],"SetEndDistance",{},1,0],[["total_length"],"SetTotalLength",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.CurveLengthData = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.CurveLengthData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.ExtensionMethod = Object.freeze({
    "Incremental" : "Incremental", "Total" : "Total"});

SPLM.GeometricUtilities.ExtensionSide = Object.freeze({
    "StartEnd" : "StartEnd", "Start" : "Start", "End" : "End", "Symmetric" : "Symmetric"});

SPLM.GeometricUtilities.ExtensionDirection = Object.freeze({
    "Natural" : "Natural", "Linear" : "Linear", "Circular" : "Circular"});

export default SPLM;